import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  textTransform: 'uppercase'
}));

export const SubTitle = styled(Typography)({
  fontWeight: 500
});

export const InfoCtn = styled('div')(({ theme }) => ({
  padding: theme.spacing(2)
}));

export const InfoItem = styled('div')(({ theme }) => ({
  wordBreak: 'break-word',
  paddingBottom: theme.spacing(1.5)
}));

export const InfoItemContent = styled('div')(({ theme }) => ({
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif;',
  fontWeight: 400,
  lineHeight: 1.5,
  letterSpacing: '0.00938em',
  paddingBottom: theme.spacing(1),
  '& p': {
    fontSize: '0.875rem'
  }
}));

export const LinkStyle = styled('div')({
  fontSize: '0.875rem',
  color: '#212121',
  textDecoration: 'none',
  borderBottom: '1px #212121 solid',
  paddingBottom: 1,
  maxWidth: 90,
  '&:hover': {
    cursor: 'pointer',
    borderBottom: '1px #fff solid'
  }
});

export const Nodata = styled('div')({
  height: '100%',
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  '& h4': {
    color: '#667'
  }
});
